import { createI18n } from 'vue-i18n';
import messages from './messages';

export default createI18n({
  messages,
  locale: 'ptBR',
  fallbackLocale: 'ptBR',
  legacy: false,
});
